<template>
  <div class="title-container">
    <h1 class="sub-title">Subscription Bindings</h1>
    <BindingDialog mode="add" @add="addBinding"/>
  </div>
  
  <!-- Debugging Helper -->
  <!-- <pre class="overflow-y-scroll h-60">Bindings from Subscription Bindings Component: {{ bindings }}</pre> -->

  <BindingsList v-model="bindings" />
</template>

<script setup lang="ts">
import BindingDialog from './BindingDialog.vue';
import BindingsList from './BindingsList.vue';
import { ref, watch } from 'vue';
const props = defineProps(['modelValue']);
const emit = defineEmits(['update:modelValue']);

const bindings = ref(props.modelValue);
watch([bindings], () => {
  emit('update:modelValue', bindings);
}, { deep: true });

function addBinding(binding: any) {
  bindings.value.push(binding)
}
</script>

<style lang="scss" scoped>
.title-container {
  display: flex;
  gap: 0.75rem;
}

.sub-title {
  font-size: 1.5em;
  font-weight: bold;

  @include theme-old {
    color: #252949;
  }

  @include theme-new {
    color: #252949;
  }

  letter-spacing: 2px;
}
</style>